module.exports = __webpack_public_path__ + "img/main-3.e5c9f794.png";